export function isCouponApiSuccess(code: unknown): boolean {
  return code === 200 || code === '200' || code === 2000 || code === '2000'
}

export function isCouponMutationSuccess(response: unknown): boolean {
  if (!response || typeof response !== 'object') return false

  const record = response as { code?: unknown; data?: unknown }
  if (isCouponApiSuccess(record.code)) return true

  if (record.data && typeof record.data === 'object' && !Array.isArray(record.data)) {
    const data = record.data as { coupon_id?: unknown; availability?: unknown }
    const couponId = data.coupon_id
    if (typeof couponId === 'string' && couponId.trim().length > 0) return true

    const availability = data.availability
    if (typeof availability === 'string' && availability.trim().length > 0) return true
  }

  return false
}

export function readCouponApiMessage(response: unknown, fallback = ''): string {
  if (!response || typeof response !== 'object') return fallback

  const record = response as { msg?: unknown; message?: unknown }
  const candidates = [record.msg, record.message]
  for (const value of candidates) {
    if (typeof value === 'string' && value.trim()) return value.trim()
  }

  return fallback
}
